import { current } from "../helpers"

window.current = current
